import React from 'react'

import Dados from './Dados'
import EmissorNotas from './EmissorNotas'
import HorarioFuncionamento from './HorarioFuncionamento'
import { Printer } from './Printer'
import IntegracaoIfood from './IntegracaoIfood'
import Integracao99Food from './Integracao99Food'
import {Services} from "./Services";

export function TabSelect({ tab }) {
  switch (tab) {
    case 'dados':
      return <Dados />
    case 'horarios':
      return <HorarioFuncionamento />
    case 'ifood':
      return <IntegracaoIfood />
    case '99food':
      return <Integracao99Food />
    case 'notas':
      return <EmissorNotas />
    case 'printer':
      return <Printer />
    case 'services':
      return <Services />
    default:
      return <Dados />
  }
}
